'use client'
import { content, features } from '@/app/(home)/data'
import { Heading, Section } from '@/components'
import { Features } from '@/components'
import { FeaturesProps } from '@/components/Features/Features.type'
import {
  aboutImageStyles,
  aboutWrapStyles,
  aboutStyles
} from '@/components/Sections/Sections.style'
import { usePartner } from '@/hooks'
import Image from 'next/image'
import Link from 'next/link'

import { AboutProps } from './Sections.type'

const About = ({ id, img, inverter, className, imgLink = '', target = '_self' }: AboutProps) => {
  const { getStoredPartner } = usePartner()

  const storedPartner = getStoredPartner()

  const contentData = content(storedPartner)
  const featuresData = features(storedPartner)

  return (
    <Section id={id} className={`${className} ${aboutStyles()}`}>
      <div className={aboutWrapStyles({ inverter })}>
        <div className="flex flex-col lg:basis-3/4 2xl:basis-2/3">
          {contentData.map((item, index) => (
            <div key={index}>
              <Heading center={false} full>
                {item.title}
              </Heading>
              <p className="whitespace-pre-line text-justify text-lg">{item.description}</p>
            </div>
          ))}
          <Section className="p-6 pb-0 pl-0 pt-0">
            <h3 className="text-xl uppercase leading-tight text-teal-800 lg:text-2xl">
              Benefícios do Consórcio BC Energia:
            </h3>
            <div className="mt-6 content-center items-center justify-center gap-6">
              {featuresData.map((feature: FeaturesProps) => (
                <Features key={feature.id} {...feature} />
              ))}
            </div>
          </Section>
        </div>
        <div className={aboutImageStyles({ inverter })}>
          <Link href={imgLink} target={target}>
            <Image
              className="ml-auto w-full rounded-lg"
              src={img}
              alt="Grupo BC Energia"
              width={1100}
              height={1500}
            />
          </Link>
        </div>
      </div>
    </Section>
  )
}

export default About
